module.exports = __webpack_public_path__ + "img/bottles-show-room.97096590.jpg";